/* eslint-disable no-multi-str */

/* eslint-disable no-unused-vars */
var H5Portal = function () {
  window.addEventListener('message', function (e) {
    var msg = e.data;

    if (msg.mtype === 'close') {
      window.MyCallbackTemp(msg.data);
    }
  }, false);
  var portal = {
    "openWindow": function openWindow(url, callBack, options) {
      var store = {
        height: document.body.style.height,
        width: document.body.style.width,
        overflow: document.body.style.overflow
      };

      window.MyCallbackTemp = function (mdata) {
        document.getElementById("__myPop__").remove();
        document.body.style.height = store.height;
        document.body.style.width = store.width;
        document.body.style.overflow = store.overflow;
        callBack(mdata);
      };

      options = options || {};
      var t = [];

      if (JSON.stringify(options) !== "{}") {
        for (var i in options) {
          var title = i;
          var value = options[i];
          var param = title + "=" + value;
          t.push(param);
        }
      }

      url = url + "?" + t.join('&');
      window.open(url, "_self");
    },
    "closeWindow": function closeWindow(result) {
      window.history.go(-1); //window.parent.postMessage({mtype: 'close', data: result}, '*');
    },
    "getLocation": function getLocation() {
      //获取当前位置
      return {
        "getCurrentPosition": function getCurrentPosition(successBack, errorBack) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
              var p = position.coords;
              successBack(p);
            });
          } else {
            alert('您的浏览器不支持获取地理位置！');
          }
        }
      };
    },
    "getCamera": function getCamera() {
      //调取摄像头
      return {
        "takePicture": function takePicture(successBack, errorBack) {
          var div = document.createElement('div');
          div.innerHTML = '<video id="video" width="640" height="480" autoplay></video>\
                        <button id="snap">Snap Photo</button>\
                        <canvas id="canvas" width="640" height="480"></canvas>';
          div.style.display = 'none';
          document.body.appendChild(div);

          var canvas = document.getElementById("canvas"),
              context = canvas.getContext("2d"),
              video = document.getElementById("video"),
              videoObj = {
            "video": true,
            "audio": false
          },
              errBack = function errBack(error) {
            errorBack("Video capture error: ", error.code);
          };

          if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia(videoObj).then(function (stream) {
              // eslint-disable-next-line no-unused-vars
              var mediaStreamTrack = typeof stream.stop === 'function' ? stream : stream.getTracks()[1];
              video.src = (window.URL || window.webkitURL).createObjectURL(stream);
              video.play();
              context.drawImage(video, 0, 0, 640, 480);
              var url = canvas.toDataURL("image/png");
              var data = {
                pic: url,
                fileName: ""
              };
              successBack(data);
            }).catch(function (err) {
              errorBack(err);
            });
          } //mediaStreamTrack && mediaStreamTrack.stop();

        },
        "takePhoto": function takePhoto(successBack, errorBack) {
          var div = document.createElement('div'); // eslint-disable-next-line no-multi-str

          div.innerHTML = '<video id="video" width="640" height="480" autoplay></video>\
                        <button id="snap">Snap Photo</button>\
                        <canvas id="canvas" width="640" height="480"></canvas>';
          div.style.display = 'none';
          document.body.appendChild(div);

          var canvas = document.getElementById("canvas"),
              context = canvas.getContext("2d"),
              video = document.getElementById("video"),
              videoObj = {
            "video": true,
            "audio": false
          },
              // eslint-disable-next-line no-unused-vars
          errBack = function errBack(error) {
            alert("Video capture error: ", error.code);
          };

          if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia(videoObj).then(function (stream) {
              // eslint-disable-next-line no-unused-vars
              var mediaStreamTrack = typeof stream.stop === 'function' ? stream : stream.getTracks()[1];
              video.src = (window.URL || window.webkitURL).createObjectURL(stream);
              video.play();
              context.drawImage(video, 0, 0, 640, 480);
              var url = canvas.toDataURL("image/png");
              var data = {
                pic: url,
                fileName: ""
              };
              successBack(data);
            }).catch(function (err) {
              errorBack(err);
            });
          }
        }
      };
    },
    "getUser": function getUser() {
      //获取用户信息
      return {
        "showUserDetail": function showUserDetail(userId, userName) {
          errorMsg();
        }
      };
    },
    "getDevice": function getDevice() {
      //获取设备信息
      return {
        "getPlatform": function getPlatform(successBack, errorBack) {
          var platform = navigator.platform;
          successBack(platform);
        },
        "getUuid": function getUuid() {
          errorMsg();
        },
        "getDpi": function getDpi() {
          errorMsg();
        }
      };
    },
    "getIM": function getIM() {
      return {
        "openChat": function openChat(address, success, error) {
          errorMsg();
        },
        "openSessionList": function openSessionList(success, error) {
          errorMsg();
        },
        "getUnreadCount": function getUnreadCount(successBack, error) {
          errorMsg();
        }
      };
    },
    "getPhone": function getPhone() {
      //拨打电话
      return {
        "call": function call(phoneNumber, successBack, errorBack) {
          errorMsg();
        }
      };
    },
    "getSMS": function getSMS() {
      //发送短信
      return {
        "sendMsg": function sendMsg(address, msg, success, error) {
          errorMsg();
        }
      };
    },
    "getAudio": function getAudio() {
      //录音
      return {
        "openRecorder": function openRecorder(successBack, errorBack) {
          errorMsg();
        }
      };
    },
    "getVibrator": function getVibrator() {
      //设备震动
      return {
        "vibrate": function vibrate(milliseconds, successBack, errorBack) {
          errorMsg();
        }
      };
    },
    "getEmail": function getEmail() {
      //发送邮件
      return {
        "sendEmail": function sendEmail(address, content, successBack, errorBack) {
          try {
            window.location.href = 'mailto:' + encodeURI(address) + '?body=' + encodeURI(content);
            successBack();
          } catch (e) {
            errorBack(e);
          }
        }
      };
    },
    "getNotification": function getNotification() {
      //提供通知
      return {
        "notice": function notice(id, title, content, clickUrl) {
          errorMsg();
        },
        "scheduleNotice": function scheduleNotice(id, title, content, firstTime, period, clickUrl) {
          errorMsg();
        },
        "cancelNotice": function cancelNotice(id) {
          errorMsg();
        }
      };
    },
    "getNews": function getNews() {
      //访问本地资讯
      return {
        "showColumnList": function showColumnList(siteId, columnId, columnName) {
          errorMsg();
        },
        "showNewsDetail": function showNewsDetail(siteId, siteName, articleId, articleTitle, url) {
          errorMsg();
        }
      };
    },
    "getLog": function getLog() {
      return {
        "log": function log(content, successBack, errorBack) {
          try {
            var div = document.createElement('div');
            div.style.display = 'none';
            div.innerHTML = content;
            document.body.appendChild(div);
            successBack();
          } catch (e) {
            errorBack(e);
          }
        }
      };
    },
    "getScan": function getScan() {
      //扫描二维码
      return {
        "scan2DBarCode": function scan2DBarCode(successBack, errorBack) {
          errorMsg();
        }
      };
    },
    "getSystem": function getSystem() {
      //提供与操作系统相关的能力
      return {
        "startActivity": function startActivity(intent, errorBack, successBack) {
          errorMsg();
        },
        "openSchema": function openSchema(schema, errorBack, successBack) {
          errorMsg();
        },
        "openFeedback": function openFeedback(errorBack, successBack) {
          errorMsg();
        }
      };
    },
    "getCryptor": function getCryptor() {
      //提供加密解密能力
      return {
        "RSA": function RSA(data, pubKey, success, error) {
          errorMsg();
        }
      };
    }
  };

  function errorMsg() {
    alert("暂不支持该功能！");
    return false;
  }

  return portal;
}();

export default H5Portal;